import React from "react";

function Icon({ className }) {
  return (
    <svg
      width="50"
      height="50"
      fill="none"
      viewBox="0 0 50 50"
      className={className}
    >
      <g>
        <circle cx="25" cy="25" r="24" fill="#fff" fillOpacity="0.5"></circle>
        <circle cx="25" cy="25" r="24.5" stroke="#fff"></circle>
      </g>
      <path
        fill="#111"
        d="M31.985 15.46C30.333 13.872 28.047 13 25.548 13c-3.818 0-6.166 1.565-7.464 2.878-1.599 1.617-2.516 3.766-2.516 5.893 0 2.672 1.118 4.722 2.99 5.485a.99.99 0 00.375.078c.395 0 .708-.259.816-.673.063-.238.21-.824.273-1.079.137-.503.026-.744-.27-1.094-.542-.64-.794-1.398-.794-2.384 0-2.927 2.18-6.038 6.22-6.038 3.206 0 5.197 1.822 5.197 4.755 0 1.85-.399 3.564-1.123 4.826-.503.877-1.388 1.922-2.746 1.922-.587 0-1.115-.242-1.448-.662-.314-.398-.418-.912-.292-1.447.143-.605.338-1.236.527-1.846.344-1.114.669-2.166.669-3.006 0-1.436-.883-2.4-2.197-2.4-1.67 0-2.977 1.695-2.977 3.86a5.74 5.74 0 00.41 2.16c-.21.892-1.46 6.19-1.698 7.189-.137.583-.963 5.189.404 5.556 1.536.413 2.909-4.073 3.049-4.58.113-.412.51-1.971.752-2.93.741.714 1.935 1.197 3.097 1.197 2.19 0 4.159-.985 5.545-2.774 1.344-1.735 2.085-4.154 2.085-6.81 0-2.077-.892-4.124-2.447-5.617z"
      ></path>
      <defs>
        <filter
          id="filter0_b_50155_60517"
          width="70"
          height="70"
          x="-10"
          y="-10"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feGaussianBlur
            in="BackgroundImage"
            stdDeviation="5"
          ></feGaussianBlur>
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_50155_60517"
          ></feComposite>
          <feBlend
            in="SourceGraphic"
            in2="effect1_backgroundBlur_50155_60517"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}

export default Icon;
